import React from 'react'
import PropTypes from 'prop-types'
import { Card, Button } from 'react-bootstrap'
import './style.css'


const PalletPickingTaskList = ({ tasks, onSelectTask }) => {
	const displayTasks = tasks
	return (
		<div className="pallet-picking-task-list">
			<h4>Pallet Picking Tasks</h4>
			{(!displayTasks || displayTasks.length === 0) && <div>No available pallet picking tasks.</div>}
			{displayTasks.map((task, idx) => (
				<Card key={task.id || idx} className="pallet-task-card mb-3">
					<Card.Body>
						<div className="pallet-task-row">
							<span className="pallet-task-label">Customer:</span>
							<span className="pallet-task-value">{task.customerName}</span>
						</div>
						<div className="pallet-task-row">
							<span className="pallet-task-label">Delivery Zone:</span>
							<span className="pallet-task-value">{task.deliveryZone}</span>
						</div>
						<div className="pallet-task-row">
							<span className="pallet-task-label">Number of Items:</span>
							<span className="pallet-task-value">{task.itemCount}</span>
						</div>
						<Button variant="primary" className="mt-3 w-100" onClick={() => onSelectTask && onSelectTask(task)}>
							Start Picking Task
						</Button>
					</Card.Body>
				</Card>
			))}
		</div>
	)
}

PalletPickingTaskList.propTypes = {
	tasks: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		customerName: PropTypes.string,
		deliveryZone: PropTypes.string,
		itemCount: PropTypes.number,
		customerId: PropTypes.string,
		deliveryAddressId: PropTypes.string,
	})),
	onSelectTask: PropTypes.func.isRequired,
}

export default PalletPickingTaskList
